import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CalculationStatisticClusterType } from '@ydistri/api-sdk';

/* Indicates if the clusterType value has been changed by the user or it is the initial value */
export enum ClusterTypeValueType {
  INITIAL,
  UPDATED,
}

export interface EvaluationSliceState {
  departmentId?: number;
  clusterType: CalculationStatisticClusterType;
  clusterTypeValueType: ClusterTypeValueType;
}

const initialState: EvaluationSliceState = {
  departmentId: undefined,
  clusterType: CalculationStatisticClusterType.Store,
  clusterTypeValueType: ClusterTypeValueType.INITIAL,
};

export const evaluationSlice = createSlice({
  name: 'evaluations',
  initialState,
  reducers: {
    setDepartmentId: (state, action: PayloadAction<number | undefined>) => {
      state.departmentId = action.payload;
    },
    setClusterType: (state, action: PayloadAction<CalculationStatisticClusterType>) => {
      state.clusterType = action.payload;
      state.clusterTypeValueType = ClusterTypeValueType.UPDATED;
    },
    resetState: () => initialState,
  },
});

export const { setDepartmentId, setClusterType } = evaluationSlice.actions;

export const evaluationsReducer = evaluationSlice.reducer;
